export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.invoices-report.index`,
        path: `/${prefix}/${pre}/invoices-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.invoices-report.index`,
                PageDescription: "Accounts/Finance Reports: Invoices report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.prints.invoices-report.index`,
        path: `/${prefix}/${pre}/invoices-report/print`,
        component: () => import('./prints/InvoiceReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.invoices-report.index`,
                PageDescription: "Accounts/Finance Reports: Invoices report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.prints.invoice-details.index`,
        path: `/${prefix}/${pre}/invoice-details/print`,
        component: () => import('./prints/InvoiceDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.invoices-report.index`,
                PageDescription: "Accounts/Finance Reports: Invoices report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.invoices-report.general`,
        path: `/${prefix}/${pre}/invoices-general-report`,
        component: () => import('./InvoicesGeneral.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.invoices-report.general`,
                PageDescription: "Accounts/Finance Reports: Invoices report Summary",
            },
        },
    },
];